import React from 'react';
import { Row } from 'react-table';
import { CLASS_PREFIX } from '../../config';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { IDataProps } from '../../types';
import { classList } from '../../util/util';

interface IRenderRow {
  index: number;
  row: Row<IDataProps>;
}

const AoyTableRenderRow = (props: IRenderRow) => {
  const { index, row } = props;
  const { original: angler } = row;
  if (! angler.hasOwnProperty('tms')) {
    angler.tms = angler.fishermenid;
  }

  const { width } = useWindowDimensions();

  // When a row is expanded to show the Angler's information we want to
  // change the color of the row.
  const expandedRowColor = row.isExpanded
    ? { style: { background: '#f9ba5e' } }
    : {};

  const stripingClass = index % 2 ? 'even' : 'odd';

  return (
    <div
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      {...row.getToggleRowExpandedProps(expandedRowColor)}
      key={`aoy-${row.id}`}
      className={classList(
        `${CLASS_PREFIX}row row-index-${row.index} index-${index}`,
        `angler-${angler.tms.toString()}`
      )}
    >
      {row.cells.map(cell => {
        // Combine props
        const styleProps = cell.getCellProps();
        const goldenAngler = row.isExpanded ? { background: '#f9ba5e' } : {};
        const newProps = { ...styleProps.style, ...goldenAngler };
        return (
          <div
            {...cell.getCellProps()}
            style={newProps}
            className={classList(
              (cell.column as any).className,
              stripingClass
            )}
          >
            {/* You can pass extra parameters to the cell as a second argument to render() */}
            {cell.render('Cell', { index, width })}
          </div>
        );
      })}
    </div>
  );
};

export default AoyTableRenderRow;
